import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex"
};
const _hoisted_2 = {
  class: "flex-body"
};
const _hoisted_3 = {
  class: "text-left"
};
const _hoisted_4 = {
  class: "localized-text"
};
const _hoisted_5 = {
  class: "list"
};
const _hoisted_6 = {
  class: "assembly-image"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "desc-button"
};
const _hoisted_9 = {
  class: "button-col"
};
const _hoisted_10 = {
  class: "wikaButtonConf",
  "data-colour": "white",
  "data-no-border": "",
  "data-type": "button"
};
const _hoisted_11 = {
  class: "assembly-image"
};
const _hoisted_12 = ["src"];
const _hoisted_13 = {
  class: "desc-button"
};
const _hoisted_14 = {
  class: "button-col"
};
const _hoisted_15 = ["data-colour", "onClick"];
const _hoisted_16 = ["data-colour"];
import { computed, ref, getCurrentInstance } from "vue";
import { useConfiguratorStore } from "@/stores/configuratorData";
import { openFullLoading } from "@/utils/tools";
import { useI18n } from "vue-i18n";
import { isQuantityChanging } from "@/hooks/summary";
import { useAdditionalAttrStore } from "@/stores/AdditionalAttrStore";
export default /*@__PURE__*/_defineComponent({
  __name: 'OptionalAssemblyDialog',
  props: /*@__PURE__*/_mergeModels({
    showClose: {
      type: Boolean,
      default: false
    },
    replaceProductSelectedItem: {
      type: String,
      default: undefined
    }
  }, {
    "modelValue": {
      type: Boolean
    },
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props) {
    const props = __props;
    const {
      eventBus
    } = getCurrentInstance()?.appContext.config.globalProperties ?? {
      eventBus: undefined
    };
    const model = _useModel(__props, "modelValue");
    const store = useConfiguratorStore();
    const {
      t
    } = useI18n();
    const currentSelectedAssemblies = ref([]);
    function getImageUrl(codeTypeId) {
      return store.getImageByCodeTypeId(codeTypeId)?.rs_w90_h90_image ?? useAdditionalAttrStore().getDataConfig.thumbnailsPlaceholderUrl;
    }
    const optionalCurrentCoding = computed(() => {
      return store.apiConfiguratorResult?.ConfiguratorResult.CurrentState.CurrentCoding.filter((item, index) => index !== 0 && item.Parent === "" && item.CodeTypeId != "LABEL" && item.Optional === "Yes" && !item?.Originators?.some(org => org.CodeTypeId !== store.lastSelectedcodeType || org.CriteriaId !== store.getLastselectedCriteriaOption?.CriteriaId || org.OptionId !== store.getLastselectedCriteriaOption?.OptionId)) ?? [];
    });
    const nonOptionalCurrentCoding = computed(() => {
      return store.apiConfiguratorResult?.ConfiguratorResult.CurrentState.CurrentCoding.filter((item, index) => index !== 0 && item.Parent === "" && item.CodeTypeId != "LABEL" && item.Optional === "No" && !item?.Originators?.some(org => org.CodeTypeId !== store.lastSelectedcodeType || org.CriteriaId !== store.getLastselectedCriteriaOption?.CriteriaId || org.OptionId !== store.getLastselectedCriteriaOption?.OptionId)) ?? [];
    });
    function onOpen() {
      currentSelectedAssemblies.value = store.selectedAssemblies.map(assembly => assembly.codeTypeId);
    }
    function isSelected(item) {
      return currentSelectedAssemblies.value.map(selected => selected).includes(item.CodeTypeId);
    }
    async function confirmSelection() {
      model.value = false;
      useConfiguratorStore().setAssemblySelectorOpen(false);
      const addedSelections = currentSelectedAssemblies.value.filter(code => !store.selectedAssemblies.map(assembly => assembly.codeTypeId).includes(code));
      const removedSelections = store.selectedAssemblies.map(assembly => assembly.codeTypeId).filter(code => !currentSelectedAssemblies.value.includes(code));
      addedSelections.forEach(store.addSelectedAssembly);
      const CurrrentType = store.initialAssemblies?.[0];
      const loading = openFullLoading(false, t("text.loading"));
      for (const removedSelection of removedSelections) {
        const element = optionalCurrentCoding.value.find(current => current.CodeTypeId === removedSelection);
        if (element && element.Optional !== "Yes") {
          await store.resetAssembly(element.CodeTypeId);
          if (CurrrentType) {
            await store.ChangeAssembly(CurrrentType);
          }
        }
        store.removeSelectedAssembly(removedSelection);
        if (store.getCurrentType == removedSelection) {
          if (store.apiConfiguratorResult?.ConfiguratorResult.CurrentState.CurrentCoding[0].CodeTypeId) {
            await store.ChangeAssembly(store.apiConfiguratorResult?.ConfiguratorResult.CurrentState.CurrentCoding[0].CodeTypeId);
          }
        }
      }
      loading.close();
      eventBus.emit("selectedAssembliesEmpty", store.selectedAssemblies.length === 0);
      const overlay = document.getElementById("overlay");
      if (overlay) {
        overlay.scrollTo({
          behavior: "smooth",
          top: 0
        });
      }
    }
    function switchOptionalAssembly(item) {
      if (currentSelectedAssemblies.value.includes(item.CodeTypeId)) {
        currentSelectedAssemblies.value = currentSelectedAssemblies.value.filter(code => code !== item.CodeTypeId);
      } else {
        currentSelectedAssemblies.value.push(item.CodeTypeId);
      }
    }
    const placeholderImage = ref("");
    placeholderImage.value = require(process.env.VUE_APP_PLACEHOLDER_IMAGE);
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: model.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => model.value = $event),
        "show-close": props.showClose,
        "append-to-body": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "modal-class": "configurator-popup",
        width: "808px",
        center: true,
        onOpen: onOpen
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_cache[1] || (_cache[1] = _createElementVNode("div", {
          class: "ic"
        }, [_createElementVNode("i", {
          class: "iconfont icon-info"
        })], -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("h3", null, _toDisplayString(_ctx.$t("header.dialog.optionalAssembly")), 1), _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("text.dialog.optionalAssemblySummary")), 1)]), _withDirectives((_openBlock(), _createElementBlock("ul", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nonOptionalCurrentCoding.value, item => {
          return _openBlock(), _createElementBlock("li", {
            key: item.CodeTypeId
          }, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_image, {
            class: "optional-assembly-image",
            src: getImageUrl(item.CodeTypeId),
            fit: "contain"
          }, {
            error: _withCtx(() => [_createElementVNode("img", {
              width: "60px",
              height: "60px",
              style: {
                "opacity": "0.5"
              },
              src: placeholderImage.value,
              alt: "Placeholder"
            }, null, 8, _hoisted_7)]),
            _: 1
          }, 8, ["src"])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("h4", null, _toDisplayString(item.CodeTypeName), 1), _createElementVNode("p", null, _toDisplayString(item.Description), 1)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("button.dialog.selected")), 1)])]);
        }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionalCurrentCoding.value, item => {
          return _openBlock(), _createElementBlock("li", {
            key: item.CodeTypeId
          }, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_image, {
            class: "optional-assembly-image",
            src: getImageUrl(item.CodeTypeId),
            fit: "contain"
          }, {
            error: _withCtx(() => [_createElementVNode("img", {
              width: "60px",
              height: "60px",
              style: {
                "opacity": "0.5"
              },
              src: placeholderImage.value,
              alt: "Placeholder"
            }, null, 8, _hoisted_12)]),
            _: 1
          }, 8, ["src"])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("h4", null, _toDisplayString(item.CodeTypeName), 1), _createElementVNode("p", null, _toDisplayString(item.Description), 1)]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", {
            class: "wikaButtonConf",
            "data-colour": isSelected(item) ? 'white' : 'blue',
            "data-no-border": "",
            "data-type": "button",
            onClick: $event => switchOptionalAssembly(item)
          }, [_createElementVNode("i", {
            class: _normalizeClass(['iconfont', isSelected(item) ? 'icon-status-error' : 'icon-plus-circle-fill'])
          }, null, 2), _createTextVNode(" " + _toDisplayString(isSelected(item) ? _ctx.$t("button.dialog.optionalAssemblyDetach") : _ctx.$t("button.dialog.optionalAssemblyAttach")), 1)], 8, _hoisted_15)])]);
        }), 128))])), [[_directive_loading, _unref(isQuantityChanging)]]), !_unref(isQuantityChanging) ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "wikaButtonConf",
          "data-colour": currentSelectedAssemblies.value.length < 1 ? 'white' : 'blue',
          "data-no-border": "",
          "data-type": "button",
          onClick: confirmSelection
        }, _toDisplayString(_ctx.$t("button.dialog.optionalAssemblyConfirm")), 9, _hoisted_16)) : _createCommentVNode("", true)])])]),
        _: 1
      }, 8, ["modelValue", "show-close"]);
    };
  }
});